/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-unused-expressions */
/* eslint-disable prettier/prettier */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-curly-brace-presence */
import React, { forwardRef, useImperativeHandle, useRef, useState } from 'react';
import styled from 'styled-components';
import Checkbox from '@material-ui/core/Checkbox';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

import debounce from 'lodash.debounce';

import { DragPreviewImage, DragSource, DropTarget } from 'react-dnd';
import fetchConfig from '../../Constants/fetch';
import {
    DiamondSm,
    WhiteMan as WhiteSource,
    RedMan as RedSource,
    GreenMan as GreenSource,
    TwoSides,
    CheckMark,
    CheckboxCheckmark,
    EmptyCheckbox,
} from '../../Constants/assets';
import { taskDataCalc, taskSourcesCalc, orDataCalc, orSourcesCalc } from '../../utils/taskCalc';

const OuterWrapper = styled.div`
    width: 338px;
    height: 280px;
    padding: 0;
    border: 1px solid ${props => props.isDragging ? props.theme.colors.darkGreen : props.theme.colors.whiteSmoke};
    ${props => !props.onlyOuter ? "border: none;" : ""};
    transition: all 0.5s ease;
    /* TODO: Need to find a fix for this */
    /* :active .flipper {
        transform: rotateY(180deg);
    } */
`;

const MiddleWrapper = styled.div`
    width: 338px;
    height: 280px;
    padding: 0;
    position: ${props => props.renderingIndependently ? 'absolute' : 'relative'};
    top: ${props => props.renderingIndependently ? `${props.top}px` : '0'};
    left: ${props => props.renderingIndependently ? `${props.left}px` : '0'};
    justify-content: center;
    align-items: center;
    display: flex;
    transition: all 0.5s ease;

`;

const CardTitle = styled.div`
    font-size: 16px;
    line-height: 19px;
    color: ${props => props.theme.colors.gray};
    padding: 12px 0 15px 15px;
    visibility: ${props => props.onlyOuter ? 'visible' : 'hidden'};
`;

const InnerWrapper = styled.div`
    width: 308px;
    height: 200px;
    box-shadow: 0px 2px 10px 2px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    margin: 0 auto;

    /* For the card flip */
    position: relative;
    transform-style: preserve-3d;
`;

const TaskNameWrapper = styled.div`
    height: 46px;
    /* background: rgba(235, 236, 237, 0.4); */
    display: flex;
`;

const TaskNumber = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 6px 7px;
    position: relative;
    top: 8px;
    left: 8px;
    margin-right: 8px;

    font-size: 15px;
    line-height: 18px;
    color: ${props => props.theme.colors.darkGreen};
    width: 32px;
    height: 30px;
    background: ${props => props.theme.colors.white};
    font-weight: 600;

    border: 1px solid ${props => props.theme.colors.lightGray};
    box-sizing: border-box;
    border-radius: 4px;
`;

const TaskName = styled.div`
    font-weight: 600;
    font-size: 15px;
    line-height: 18px;
    display: flex;
    align-items: center;
    color: ${props => props.theme.colors.darkGray};
    max-width: 220px;

    /* Inside Auto Layout */

    flex: none;
    order: 1;
    flex-grow: 0;
    margin: 0px 8px;
`;

const TaskBody = styled.div`
    height: 154px;
`;

const ConstraintContainer = styled.div`
    height: 35px;
    padding: 4px 16px 0 15px;
`;

const InfoWrapper = styled.div`
    background: rgba(252, 157, 44, 0.1);
    border-radius: 4px;
    font-size: 12px;
    line-height: 20px;
    padding: 0 18px 0 9px;
    color: ${props => props.theme.colors.orange};
`;

const DataContainer = styled.div`
    height: 48px;
    border: 1px solid ${props => props.theme.colors.whiteSmoke};
    border-left: 0;
    border-right: 0;
    display: flex;
    padding: 4px 0 0 16px;
`;

const DataUnit = styled.div`
    width: 33.33%;
    height: 100%;
    font-size: 12px;
    line-height: 14px;
    color: ${props => props.theme.colors.gray};
`;

const DataUnitValue = styled.div`
    font-weight: 600;
    font-size: 21px;
    line-height: 25px;
    color: ${props => props.theme.colors.darkGray};
`;

const SourcesWrapper = styled.div`
    height: 48px;
    font-size: 12px;
    line-height: 14px;
    padding: 4px 0 0 16px;
`;

const SourcesContainer = styled.div`
    /* display: flex; */
    align-items: center;
    font-size: 12px;
    color: ${props => props.theme.colors.gray};
`;

const Sources = {
    general: {
        margin: '0 5px 0 11px',
    },
    leftMargin: {
        marginLeft: '31px',
    },
};

const diamondStyles = {
    marginLeft: '12px',
};

const CheckedWrapper = styled.div`
    position: absolute;
    height: 200px;
    width: 308px;
    background: rgba(255, 255, 255, 0.8);
    z-index: 1;
    justify-content: center;
    align-items: center;
    display: ${props => (props.isChecked ? `flex` : `none`)};
    border-radius: 8px;
`;

const ExtraInfo = styled.div`
    margin-top: 5px;
    display: flex;
    font-size: 12px;
    line-height: 14px;
    width: 76%;
    color: ${props => props.theme.colors.darkGray};
`;

const Extras = styled.div`
    display: flex;
`;

// Card flip
const CardFront = styled.div`
    z-index: 99;
    transform: rotateY(0deg);
    -ms-transform: rotateY (0deg);
    -webkit-transform: rotateY (0deg);
    -moz-transform: rotateY (0deg);
    -o-transform: rotateY (0deg);
    border-radius: 8px;

    background: ${props =>
        props.checked ? props.theme.colors.lightGreen : props.theme.colors.white};
    border: ${props => (props.checked ? `1px solid ${props.theme.colors.darkGreen}` : 'none')};

`;


const CardBack = styled.div`

    background: ${props =>
        props.checked ? props.theme.colors.lightGreen : props.theme.colors.white};
    border: ${props => (props.checked ? `1px solid ${props.theme.colors.darkGreen}` : 'none')};

    position: absolute;
    top: 0;
    width: 100%;
    height: 101.3%;
    border-radius: 8px;

    transform: rotateY(180deg);
    -ms-transform: rotateY (180deg);
    -webkit-transform: rotateY (180deg);
    -moz-transform: rotateY (180deg);
    -o-transform: rotateY (180deg);

`;

const TwoSidesButton = styled.button`
    position: relative;
    bottom: 27px;
    left: 8px;
    background: none;
    height: 56px;
    border: none;
    width: 56px;
    cursor: pointer;

    :active {
        transform: translateY(2px);
        transition: 0.1s;
    }
`;

const DataUnitWrapper = styled.div`
    display: flex;
`;

const ResourcesWrapper = styled.div`
    display: flex;
    padding-top: 4px;
    color: initial;
`;

const CardCheckbox = styled(Checkbox)`
    && {
        position: absolute;
        right: 0;
    }
`;

const CustomDNDEnd = (e) => {
    document.getElementById("CustomDNDStart")?.remove();
}

const Card = forwardRef(function Card( // forwards the ref that has been passed to the Card components
    {
        onlyOuter,
        name,
        number,
        id,
        cardId,
        taskIdnumberInDB,
        completed,
        costMoney,
        orTask = false,
        constraint = false,
        relationships = false,
        isDragging,
        connectDragSource,
        connectDropTarget,
        connectDragPreview,
        index,
        stepChange,
        valueChange,
        costResourcesExpensive,
        costResourcesNormal,
        costResourcesSenior,
        taskname,
        checkedTaskHandler,
        checkedTask,
        setCheckedTaskDBId,
        isHovered,
        disabled,
        orTaskChangeHandler,
        setChangesMade,
        changesMade,
        isPaused,
        showIsPaused,
        playerStatus,
        newTurn,
        isPlanning,
        SoundPlay,
        soundForFlipAndCards,
        updateOrTaskFlip,
        // isOrFlipped,
        allCards,
        orFlipped,
        setOrFlipped,
        setCheckedTask,
        top,
        left,
        renderingIndependently,
        handleDrop,
        setDraggedId,
        fullItem,
        setCheckedTaskRedo,
        redo,
        oneLessStep,
    },
    ref,
) {
    // console.log('task state flipped: ', isOrFlipped, number);
    const { isOrFlipped } = allCards.filter(task => task.number === number)[0];
    const [rotate, setRotate] = useState(isOrFlipped ? '1' : '0');
    // console.log('flipping mech: ', isOrFlipped, rotate);
    const [orTaskChecked, setOrTaskChecked] = useState(false);
    const { t } = useTranslation();

    const taskData = {
        budget: costMoney,
        steps: stepChange,
        earned: valueChange,
    };

    const taskSources = {
        green: costResourcesExpensive,
        red: costResourcesSenior,
        white: costResourcesNormal,
    };
    const orTaskData = orDataCalc(taskData);
    const orTaskSources = orSourcesCalc(taskSources);
    const constraintContent = constraint > 0 && (
        <InfoWrapper testID="info">{t(`project_sheet.project_scope.tasks.${taskIdnumberInDB}.task_constraint`, { taskIdnumberInDB })} </InfoWrapper>
    );
    const commentOrTaskTurn = async () => {
        const baseUrl = `${fetchConfig.prefix}/game/commentit`;
        const data = {
            gameId: playerStatus.gameId,
            userId: playerStatus.id,
            commentContent: 'Changed selection of choice task in turn',
        };
        if (isPlanning) {
            const result = await axios.get(
                `${baseUrl}?gameId=${data.gameId}&userId=${data.userId}&comment=${encodeURI(
                    data.commentContent,
                )}`,
                data,
            );
        }
    };
    const twoSidesView = orTask && (
        <TwoSidesButton
            onClick={() => {
                const isFlipped = rotate === '0';

                setOrFlipped('transform 1s');
                commentOrTaskTurn();
                setRotate(!isOrFlipped ? '1' : '0');
                orTaskChangeHandler(number, !isOrFlipped, disabled); // disabled is for pause/ no pause 
                setChangesMade(true);
                SoundPlay(soundForFlipAndCards);
                updateOrTaskFlip(number, !isOrFlipped);
                // setOrTaskChecked(true);
                setCheckedTask(null);
            }}
            className="twoSidesButton"
        >
            <TwoSides />
        </TwoSidesButton>
    );

    const opacity = 1;
    const elementRef = useRef(null);

    // connectDragSource(elementRef);
    // connectDropTarget(elementRef);

    // adds the option to write component.getNode() outside of the current component
    useImperativeHandle(ref, () => ({
        getNode: () => elementRef.current,
        boundries: () => elementRef.current.getBoundingClientRect(),
    }));

    const CustomDNDStart = (e) => {
        if (completed) return;
        const clone = e.target.cloneNode(true);
        const root = document.getElementById("root");

        clone.style.transform = "rotate(-10deg)";
        if (e.target.attributes.rotate.value == 1) {  // double equal signs because we also want to check for a string
            clone.style.transform += " scale(-1, 1)";  // if card is an ORTask
        }
        clone.style.zIndex = "2";
        clone.style.position = "absolute";

        clone.id = "CustomDNDStart";

        root.appendChild(clone);
    };

    return (<>
        <OuterWrapper onlyOuter={onlyOuter} hovered={isHovered} isDragging={isDragging} className="flipperContainer" style={{ background: redo ? '#E0F7F7' : '' }}>
            <CardTitle testID="cardTitle" onlyOuter={onlyOuter}>
                <span>{index > 8 ? ++index : `0${++index}`}</span>
                {redo &&
                    <span style={{ marginLeft: '11px', color: '#005857', fontSize: '14px', fontWeight: '500', position: 'relative' }}>
                        <span style={{ position: 'absolute', width: '100%', height: '100%', top: 0, left: 0, background: 'rgba(224, 247, 247, 0.6)' }} />
                        Reopened
                    </span>
                }
            </CardTitle>
            <DragPreviewImage src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" connect={() => { }} />  {/* a blank 1x1 px image */}
            {!onlyOuter && <InnerWrapper
                ref={elementRef}
                style={{ opacity, transition: 'all 0.5s ease', left: renderingIndependently ? "" : left, top: renderingIndependently ? "" : top }}
                className="flipper"
                rotate={isOrFlipped ? '1' : '0'}
            >
                {isOrFlipped ? (
                    <CardBack checked={checkedTask === id && orTaskChecked}>
                        <CheckedWrapper testID="checkedBack" isChecked={completed}>
                            <CheckMark />
                        </CheckedWrapper>
                        <CardCheckbox
                            disabled={disabled}
                            // color="black"
                            onChange={() => {
                                checkedTaskHandler(id, true);
                                setCheckedTaskRedo(redo);
                                setOrTaskChecked(true);
                                setCheckedTaskDBId(taskIdnumberInDB);
                            }}
                            checked={checkedTask === id && orTaskChecked}
                            icon={
                                <EmptyCheckbox
                                    style={{
                                        width: '24px',
                                        height: '24px',
                                        transform: 'scale(0.9)',
                                    }}
                                />
                            }
                            checkedIcon={
                                <CheckboxCheckmark style={{ width: '24px', height: '24px' }} />
                            }
                        />
                        <TaskNameWrapper>
                            <TaskNumber testID="taskNumberBack">T{`${id}`}</TaskNumber>
                            <TaskName testID="taskNameBack">{t(`project_sheet.project_scope.tasks.${taskIdnumberInDB}.or`, { taskIdnumberInDB })}</TaskName>
                        </TaskNameWrapper>
                        <TaskBody>
                            <ConstraintContainer>{constraintContent}</ConstraintContainer>
                            <DataContainer>
                                <DataUnit>
                                    {t(`global_variables.cost`)}
                                    <DataUnitValue testID="budget">
                                        ${orTaskData.budget}
                                    </DataUnitValue>
                                </DataUnit>
                                <SourcesContainer>
                                    {t(`global_variables.resources.resources`)}
                                    <ResourcesWrapper>
                                        {/* TODO: Add classes to the sources so we can test them */}
                                        <WhiteSource
                                            style={{ ...Sources.general, marginLeft: 0 }}
                                        />
                                        {orTaskSources.white}
                                        <RedSource
                                            style={{ ...Sources.leftMargin, ...Sources.general }}
                                        />
                                        {orTaskSources.red}
                                        <GreenSource
                                            style={{ ...Sources.leftMargin, ...Sources.general }}
                                        />
                                        {orTaskSources.green}
                                    </ResourcesWrapper>
                                </SourcesContainer>
                            </DataContainer>
                            <SourcesWrapper>
                                <DataUnitWrapper>
                                    <DataUnit>
                                        {t(`global_variables.value`)}
                                        <DataUnitValue testID="earnedValue" style={{ textDecoration: redo ? 'line-through' : '' }}>
                                            {orTaskData.earned}
                                            <DiamondSm style={diamondStyles} />
                                        </DataUnitValue>
                                    </DataUnit>
                                    <DataUnit>
                                        {t(`global_variables.steps`)}
                                        <DataUnitValue testID="steps" style={{ display: 'flex', textDecoration: redo ? 'line-through' : '' }}>
                                            <div style={{ textDecoration: (oneLessStep && orTaskData.steps > 0) ? 'line-through' : '' }}>
                                                {orTaskData.steps}
                                            </div>
                                            <div style={{ display: (oneLessStep && orTaskData.steps > 0) ? 'block' : 'none', marginLeft: '4px' }}>
                                                {orTaskData.steps - 1}
                                            </div>
                                        </DataUnitValue>
                                    </DataUnit>
                                </DataUnitWrapper>
                                <Extras>
                                    {relationships.length > 0 ? (
                                        <ExtraInfo testID="bottomInfo">
                                            {t(`project_sheet.project_scope.tasks.predecessor`)}{' '}
                                            {relationships.map((current, index2) => {
                                                const isLast = index2 === relationships.length - 1;
                                                return (
                                                    <div key={index2}>
                                                        {`T${current}`}
                                                        {!isLast ? <div style={{ display: 'inline' }}>,</div> : <div />}
                                                    </div>
                                                );
                                            })}
                                        </ExtraInfo>
                                    ) : (
                                        <ExtraInfo testID="bottomInfo" />
                                    )}
                                    {twoSidesView}
                                </Extras>
                            </SourcesWrapper>
                        </TaskBody>
                    </CardBack>
                ) : (
                    <CardFront checked={checkedTask === id && !orTaskChecked}>
                        <CardCheckbox
                            disabled={disabled}
                            // color="black"
                            onChange={() => {
                                checkedTaskHandler(id, false);
                                setCheckedTaskRedo(redo);
                                setOrTaskChecked(false);
                                setCheckedTaskDBId(taskIdnumberInDB);
                            }}
                            checked={checkedTask === id && !orTaskChecked}
                            icon={
                                <EmptyCheckbox
                                    style={{ width: '24px', height: '24px', transform: 'scale(0.9)' }}
                                />
                            }
                            checkedIcon={
                                <CheckboxCheckmark style={{ width: '24px', height: '24px' }} />
                            }
                        />
                        <CheckedWrapper testID="checked" isChecked={completed}>
                            <CheckMark />
                        </CheckedWrapper>
                        <TaskNameWrapper>
                            <TaskNumber testID="taskNumber">T{`${id}`}</TaskNumber>
                            <TaskName testID="taskName">{t(`project_sheet.project_scope.tasks.${taskIdnumberInDB}.task_title`, { taskIdnumberInDB })}</TaskName>
                        </TaskNameWrapper>
                        <TaskBody>
                            <ConstraintContainer>{constraintContent}</ConstraintContainer>
                            <DataContainer>
                                <DataUnit>
                                    {t(`global_variables.cost`)}
                                    <DataUnitValue testID="budget">${taskData.budget}</DataUnitValue>
                                </DataUnit>
                                <SourcesContainer>
                                    {t(`global_variables.resources.resources`)}
                                    <ResourcesWrapper>
                                        {/* TODO: Add classes to the sources so we can test them */}
                                        <WhiteSource style={{ ...Sources.general, marginLeft: 0 }} />
                                        {taskSources.white}
                                        <RedSource
                                            style={{ ...Sources.leftMargin, ...Sources.general }}
                                        />
                                        {taskSources.red}
                                        <GreenSource
                                            style={{ ...Sources.leftMargin, ...Sources.general }}
                                        />
                                        {taskSources.green}
                                    </ResourcesWrapper>
                                </SourcesContainer>
                            </DataContainer>
                            <SourcesWrapper>
                                <DataUnitWrapper>
                                    <DataUnit>
                                        {t(`global_variables.value`)}
                                        <DataUnitValue testID="earnedValue" style={{ textDecoration: redo ? 'line-through' : '' }}>
                                            {taskData.earned}
                                            <DiamondSm style={diamondStyles} />
                                        </DataUnitValue>
                                    </DataUnit>
                                    <DataUnit>
                                        {t(`global_variables.steps`)}
                                        <DataUnitValue testID="steps" style={{ display: 'flex', textDecoration: redo ? 'line-through' : '' }}>
                                            <div style={{ textDecoration: (oneLessStep && taskData.steps > 0) ? 'line-through' : '' }}>
                                                {taskData.steps}
                                            </div>
                                            <div style={{ display: (oneLessStep && taskData.steps > 0) ? 'block' : 'none', marginLeft: '4px' }}>
                                                {taskData.steps - 1}
                                            </div>
                                        </DataUnitValue>
                                    </DataUnit>
                                </DataUnitWrapper>
                                <Extras>
                                    {relationships.length > 0 ? (
                                        <ExtraInfo testID="bottomInfo">
                                            {t(`project_sheet.project_scope.tasks.predecessor`)}{' '}
                                            {relationships.map((current, index2) => {
                                                const isLast = index2 === relationships.length - 1;
                                                return (
                                                    <div key={index2}>
                                                        {`T${current}`}
                                                        {!isLast ? <div style={{ display: 'inline' }}>,</div> : <div />}
                                                    </div>
                                                );
                                            })}
                                        </ExtraInfo>
                                    ) : (
                                        <ExtraInfo testID="bottomInfo" />
                                    )}
                                    {twoSidesView}
                                </Extras>
                            </SourcesWrapper>
                        </TaskBody>
                    </CardFront>
                )}
            </InnerWrapper>
            }
        </OuterWrapper >
    </>
    );
});
// let currentDragIndex = -1;
// let dragId;
export default Card